import React from 'react';
import columns from './columns';
import messages from './messages';
import SupplierOrderControls from './supplier-orders-controls/supplier-orders-controls';
import Breadcrumb from 'components/Common/Breadcrumb';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import {Container} from 'reactstrap';
import Table from 'features/table';
import {CompactSupplierOrder} from 'features/commercial/orders/types/order';

const SupplierOrdersPage = () => {
  const {t} = useTranslation();
  const makeRowClassName = (row: CompactSupplierOrder) =>
    row.status === 'VALIDATED' ? 'bg-gray-light' : '';

  return (
    <div className="page-content pb-0">
      <Helmet>
        <title> {t(...messages.title())}</title>
      </Helmet>

      <Container fluid>
        <Breadcrumb
          breadcrumbItems={[
            {title: t('common.dashboard'), path: '/dashboard'},
            {title: t(...messages.title()), path: '#'},
          ]}
        />
        <Table
          url="orders?type=SUPPLIER"
          otherParams={{
            delimiter: '|',
          }}
          columns={columns}
          hideSearch
          makeRowClassName={makeRowClassName}
          filtersComponent={SupplierOrderControls}
          name="supplier-orders"
        />
      </Container>
    </div>
  );
};

export default SupplierOrdersPage;
